import React from "react";

export default function Loader() {
	return (
		<div className="h-full w-full flex items-center justify-center">
			<div
				className="Loader 
        h-10 aspect-square 
        rounded-full border-t 
        mt-[-50px]
        border-main
        animate-spin
        opacity-60
        "
			/>
		</div>
	);
}
